var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 28,
    viewBox: "0 0 148 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3964 0C19.3515 0 24.7928 5.01247 24.7928 11.4835C24.7928 17.9545 19.3719 22.967 12.3964 22.967C5.42087 22.967 0 17.9545 0 11.4835C0 5.01247 5.42087 0 12.3964 0ZM12.3964 15.099C14.2988 15.099 15.833 13.5583 15.833 11.6478C15.833 9.73734 14.2988 8.19662 12.3964 8.19662C10.494 8.19662 8.95978 9.73734 8.95978 11.6478C8.95978 13.5583 10.494 15.099 12.3964 15.099Z",
    fill: "#F2B200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.89781e-09H9.14388V14.38H16.0171V22.2891H0V4.89781e-09Z",
    transform: "translate(26.0815 0.328674)",
    fill: "#F2B200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.89781e-09H15.9762V7.45708H9.14389V8.64857H14.667V13.9486H9.14389V15.2223H16.4058V22.3096H0V4.89781e-09Z",
    transform: "translate(43.5713 0.328674)",
    fill: "#F2B200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.49708e-06 4.89781e-09H9.14388V6.90242H13.7465V4.89781e-09H22.8904V22.3096H13.7465V14.1746H9.14388V22.3096H-2.49708e-06V4.89781e-09Z",
    transform: "translate(61.3276 0.328674)",
    fill: "#F2B200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.24854e-06 4.89781e-09H8.40746C13.7465 4.89781e-09 19.7197 1.54072 19.7197 7.90902C19.7197 13.6405 14.933 15.9413 9.45073 15.9413H9.14388V22.2891H-1.24854e-06V4.89781e-09ZM9.38935 10.292C10.944 10.292 11.6804 9.47029 11.6804 8.4226C11.6804 7.37491 10.9031 6.55319 9.38935 6.55319H9.14388V10.3125H9.38935V10.292Z",
    transform: "translate(86.0996 0.328674)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46883 4.89781e-09H17.2036L25.6724 22.3096H15.7921L15.0352 19.3925H9.94168L9.08252 22.3096H-2.49708e-06L8.46883 4.89781e-09ZM13.5624 13.7843L12.5805 9.26486H12.5191L11.5373 13.7843H13.5624Z",
    transform: "translate(102.649 0.328674)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16199 12.8804L4.99417e-06 4.89781e-09H10.3099L12.826 5.0741H12.8874L15.4239 4.89781e-09H25.386L17.3059 12.6134V22.3096H8.16199V12.8804Z",
    transform: "translate(122.614 0.328674)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14388 3.57447H-2.49708e-06V3.1346e-07H9.14388",
    transform: "translate(130.776 24.4255)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cca3cbc97bea268f393fcd6bd22d2a8.svg";
export { ForwardRef as ReactComponent };